import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ipsa-forms',
  templateUrl: './ipsa-forms.component.html',
  styleUrls: ['./ipsa-forms.component.scss']
})
export class IpsaFormsComponent implements OnInit {

  formJson: any = [
    {
      id: 3,
      formName : 'Social Assessment',
      pathName: 'Social Assessment',
      image: '/assets/images/socialPerformance-icon.svg',
    },
    {
      id: 4,
      formName : 'Environmental Assessment',
      pathName: 'Environmental Assessment',
      image: '/assets/images/environmentalPerf-icon.svg',
    },
    {
      id: 5,
      formName : 'Building Safety Assessment',
      pathName: 'Building Safety Assessment',
      image: '/assets/images/buildingSafetyPerf-icon.svg',
    },
  ];

  constructor( public router: Router) { }

  ngOnInit(): void {
  }

  toggle(data: any): void {
    this.router.navigate(['/prism-forms-list'], {queryParams: {
      formName: data.pathName
    }
});

  }
  backToForm(): void {
    this.router.navigate(['/prism']);
  }
}
